import React from "react";
import {useTranslation} from "react-i18next";

import MenuItem from "@mui/material/MenuItem";

import {getSeasonLabel} from "./utils";
import MDInput from "../../materialDashboard/components/MDInput";

const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: "200px"
        }
    },
};

const SeasonSelect = ({
                          selectedSeason,
                          setSelectedSeason,
                          yearFrom = 1970,
                          optionsFrom = null,
                          allowEmpty = false,
                          availableSeasons: originalAvailableSeason,
                          ...props
                      }) => {
    const {t} = useTranslation("inputs");

    const availableSeasons = originalAvailableSeason ?? Array.from({length: new Date().getFullYear() - yearFrom + 1}, (_, i) => {
        let year = new Date().getFullYear() - i;
        if (new Date().getMonth() < 9) {
            year -= 1;
        }
        return year
    });

    const seasonOptions = availableSeasons.sort((a, b) => b - a).filter(
        season => optionsFrom === null || season >= optionsFrom).map(season => {
        return {
            label: getSeasonLabel(season),
            value: season
        }
    })

    const handleSeasonChange = (event) => {
        const value = event.target.value;
        if (value === "") {
            setSelectedSeason(null);
        } else {
            setSelectedSeason(event.target.value);
        }
    }

    return <MDInput label={t("seasonSelect.label")}
                    value={selectedSeason ?? ""}
                    onChange={handleSeasonChange}
                    variant="standard"
                    select
                    SelectProps={{MenuProps: MenuProps}}
                    {...props}>
        {
            allowEmpty && <MenuItem key='nothing' value="">
            --
            </MenuItem>
        }
        {
            seasonOptions.map(season => (
                <MenuItem key={season.label} value={season.value}>{season.label}</MenuItem>
            ))
        }
    </MDInput>
}

export default SeasonSelect;